import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiShoppingCart, FiUser, FiLogOut, FiMenu, FiX, FiSettings, FiHome, FiPackage, FiMail } from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';

const Navbar = () => {
  const { user, isAuthenticated, isAdmin, login, logout } = useAuth();
  const { getCartCount } = useCart();
  const [menuOpen, setMenuOpen] = useState(false);

  const cartCount = getCartCount();

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <Link to="/" className="navbar-brand" style={{ flexDirection: 'column', alignItems: 'flex-start', lineHeight: 1.2 }}>
          <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <img src="/images/logo.png" alt="Swaad Pickles" className="navbar-logo" />
            Swaad Pickles
          </span>
          <span style={{ fontSize: '0.62rem', fontWeight: 400, color: 'var(--text-light)', letterSpacing: '0.01em', paddingLeft: 2 }}>
            homemade with love · by Manisha Suthar
          </span>
        </Link>

        <button
          className="navbar-menu-btn"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          {menuOpen ? <FiX /> : <FiMenu />}
        </button>

        <div className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          <Link to="/" onClick={() => setMenuOpen(false)}>
            <FiHome /> Home
          </Link>

          <Link to="/contact" onClick={() => setMenuOpen(false)}>
            <FiMail /> Contact Us
          </Link>

          {isAuthenticated && (
            <>
              <Link to="/cart" onClick={() => setMenuOpen(false)}>
                <FiShoppingCart />
                Cart
                {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
              </Link>

              <Link to="/orders" onClick={() => setMenuOpen(false)}>
                <FiPackage /> My Orders
              </Link>

              {isAdmin && (
                <Link to="/admin" onClick={() => setMenuOpen(false)}>
                  <FiSettings /> Admin
                </Link>
              )}

              <div className="navbar-user">
                {user.avatar && (
                  <img src={user.avatar} alt={user.name} className="navbar-avatar" />
                )}
                <button onClick={() => { logout(); setMenuOpen(false); }}>
                  <FiLogOut /> Logout
                </button>
              </div>
            </>
          )}

          {!isAuthenticated && (
            <button onClick={login}>
              <FiUser /> Sign In
            </button>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
